(() => {
  if (window.soldoutNewsletterInstalled) return;
  window.soldoutNewsletterInstalled = true;

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const action = new URL(form.action, location.href);
    if (action.hostname !== 'manage.kmail-lists.com' ||
        action.pathname !== '/subscriptions/subscribe' ||
        action.searchParams.get('a') !== 'KBbFED' ||
        action.searchParams.get('g') !== 'HBs94n') return;

    event.preventDefault();
    if (form.dataset.submitting === 'true') return;
    if (!form.reportValidity()) return;

    const email = form.querySelector('input[name="email"]');
    if (!email) return;
    let message = Array.from(
      form.parentElement.querySelectorAll('[data-newsletter-status]')
    ).find((container) => !form.contains(container));
    // Remove feedback left inside the form by the earlier script.
    form.querySelectorAll('[data-newsletter-status]').forEach((container) => container.remove());
    if (!message) {
      message = document.createElement('div');
      message.dataset.newsletterStatus = '';
      form.after(message);
    }
    message.setAttribute('role', 'status');
    message.setAttribute('aria-live', 'polite');
    message.setAttribute('aria-atomic', 'true');
    message.removeAttribute('hidden');

    const buttons = Array.from(form.querySelectorAll('[type="submit"]'));
    const disabledStates = buttons.map((button) => button.disabled);
    form.dataset.submitting = 'true';
    form.setAttribute('aria-busy', 'true');
    buttons.forEach((button) => { button.disabled = true; });
    message.textContent = 'Signing you up…';
    message.dataset.state = 'loading';
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 15000);

    try {
      const response = await fetch(
        'https://a.klaviyo.com/client/subscriptions/?company_id=KBbFED',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/vnd.api+json',
            Accept: 'application/vnd.api+json',
            revision: '2026-07-15'
          },
          signal: controller.signal,
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                custom_source: 'SoldOut NYC footer newsletter',
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      email: email.value.trim(),
                      subscriptions: {
                        email: { marketing: { consent: 'SUBSCRIBED' } }
                      }
                    }
                  }
                }
              },
              relationships: {
                list: { data: { type: 'list', id: 'HBs94n' } }
              }
            }
          })
        }
      );
      // The API accepts requests asynchronously and returns an empty 202 body.
      if (response.status !== 202) {
        message.textContent = response.status === 429
          ? 'Please wait a moment before trying again.'
          : 'We couldn’t submit your signup. Please try again.';
        message.dataset.state = 'error';
        return;
      }
      message.textContent = 'Thanks for signing up! If you receive a confirmation email, please confirm your subscription.';
      message.dataset.state = 'success';
      email.value = '';
    } catch (error) {
      message.textContent = 'We couldn’t confirm your signup. Please check your connection and try again.';
      message.dataset.state = 'error';
    } finally {
      clearTimeout(timeout);
      delete form.dataset.submitting;
      form.removeAttribute('aria-busy');
      buttons.forEach((button, index) => { button.disabled = disabledStates[index]; });
    }
  });
})();
